import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground border-border",
        // Status badges
        construction: "bg-amber-100 text-amber-800 border-amber-200",
        evolution: "bg-cyan-100 text-cyan-800 border-cyan-200",
        ready: "bg-emerald-100 text-emerald-800 border-emerald-200",
        // Job type badges
        apprentice: "bg-violet-100 text-violet-800 border-violet-200",
        internship: "bg-blue-100 text-blue-800 border-blue-200",
        junior: "bg-indigo-100 text-indigo-800 border-indigo-200",
        // Interest tags
        interest: "bg-secondary text-secondary-foreground border-border hover:bg-primary hover:text-primary-foreground hover:border-primary cursor-pointer",
        "interest-selected": "bg-primary text-primary-foreground border-primary",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(({ className, variant, ...props }, ref) => {
  return <span ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />;
});
Badge.displayName = "Badge";

export { Badge, badgeVariants };
